import {
    SearchFilter,
    SortModel
} from "@/lib/depict-client/types/api/ProductListingRequestV3"

export const sortConfig: { [key: string]: SortModel } = {
    _relevance: {
        field: "_relevance",
        order: "desc",
        meta: {
            title: "Recommended",
            values: ["desc"],
            names: ["Recommended"]
        }
    },
    sale_price_desc: {
        field: "sale_price",
        order: "desc",
        meta: {
            title: "Price, high to low",
            values: ["desc"],
            names: ["Price, high to low"]
        }
    },
    sale_price_asc: {
        field: "sale_price",
        order: "asc",
        meta: {
            title: "Price, low to high",
            values: ["asc"],
            names: ["Price, low to high"]
        }
    },
    product_timestamp: {
        field: "product_timestamp",
        order: "desc",
        meta: {
            title: "Newest first",
            values: ["desc"],
            names: ["Newest first"]
        }
    }
}

type FilterConfigItem = {
    field: SearchFilter["field"]
    op: SearchFilter["op"]
}

export const filterConfig: FilterConfigItem[] = [
    {
        field: "size" as SearchFilter["field"],
        op: "in" as SearchFilter["op"]
    },
    {
        field: "color_name" as SearchFilter["field"],
        op: "in" as SearchFilter["op"]
    },
    {
        field: "fit" as SearchFilter["field"],
        op: "in" as SearchFilter["op"]
    }
    // Additional fields for later implementation
    // {
    //     field: "sale_price",
    //     op: "inrange" as SearchFilter["op"]
    // },
    // {
    //     field: "product_category_hierarchy",
    //     op: "in" as SearchFilter["op"]
    // },
    // {
    //     field: "in_stock",
    //     op: "eq" as SearchFilter["op"]
    // }
]
